import { gql } from '@apollo/client'

const UPDATE_SHIPPING_GROUPS = gql`
  mutation UpdateShippingGroups(
    $groupId: Int!
    $groupType: String!
    $productIds: [ID]!
    $allSelected: boolean!
    $filters: [String]
    $userId: [String]
  ) {
    updateShippingGroups(
      groupId: $groupId
      groupType: $groupType
      productIds: $productIds
      allSelected: $allSelected
      filters: $filters
      userId: $userId
    ) {
      id
    }
  }
`

const CREATE_SHIPPING_GROUP = gql`
  mutation CreateShippingGroup(
    $name: String
    $amount: Int
    $shippingGroupTypeName: String
    $storeId: String
  ) {
    createShippingGroup(
      name: $name
      amount: $amount
      shippingGroupTypeName: $shippingGroupTypeName
      storeId: $storeId
    ) {
      name
      amount
    }
  }
`

const EDIT_SHIPPING_GROUP = gql`
  mutation EditShippingGroup($groupId: Int, $name: String, $amount: Int, $storeId: String) {
    editShippingGroup(groupId: $groupId, name: $name, amount: $amount, storeId: $storeId) {
      name
      amount
    }
  }
`

const REMOVE_SHIPPING_GROUP = gql`
  mutation RemoveShippingGroup($groupId: Int, $storeId: String) {
    removeShippingGroup(groupId: $groupId, storeId: $storeId) {
      name
      amount
    }
  }
`

const SET_GEARFLOW_SHIPPING = gql`
  mutation SetGearflowShipping($storeId: String, $gearflowShipping: Boolean) {
    setGearflowShipping(storeId: $storeId, gearflowShipping: $gearflowShipping) {
      gearflowShipping
    }
  }
`

const SET_GEARFLOW_SHIPPPING_STORE_ORDER = gql`
  mutation SetGearflowShippingStoreOrder($storeOrderId: String, $gearflowShipping: Boolean) {
    setGearflowShippingStoreOrder(
      storeOrderId: $storeOrderId
      gearflowShipping: $gearflowShipping
    ) {
      gearflowShipping
    }
  }
`

const CREATE_SHIPPING_LABEL = gql`
  mutation CreateShippingLabel(
    $storeOrderId: String
    $shipToAddress: AddressInput
    $shipToPhone: String
    $shipFromAddress: AddressInput
    $shipFromPhone: String
    $weight: WeightInput
    $dimensions: DimensionsInput
    $shipmentItems: [ShipmentItemInput]
    $labelSize: String
    $shipDate: String
  ) {
    createShippingLabel(
      storeOrderId: $storeOrderId
      shipToAddress: $shipToAddress
      shipToPhone: $shipToPhone
      shipFromAddress: $shipFromAddress
      shipFromPhone: $shipFromPhone
      weight: $weight
      dimensions: $dimensions
      shipmentItems: $shipmentItems
      labelSize: $labelSize
      shipDate: $shipDate
    ) {
      url
    }
  }
`
const MARK_AS_SHIPPED = gql`
  mutation MarkAsShipped(
    $shipmentId: String
    $storeOrderId: String
    $sendEmail: Boolean
    $notes: String
  ) {
    markAsShipped(
      shipmentId: $shipmentId
      storeOrderId: $storeOrderId
      sendEmail: $sendEmail
      notes: $notes
    ) {
      shipmentId
    }
  }
`

export {
  UPDATE_SHIPPING_GROUPS,
  REMOVE_SHIPPING_GROUP,
  EDIT_SHIPPING_GROUP,
  CREATE_SHIPPING_GROUP,
  SET_GEARFLOW_SHIPPING,
  SET_GEARFLOW_SHIPPPING_STORE_ORDER,
  CREATE_SHIPPING_LABEL,
  MARK_AS_SHIPPED,
}
